import React from "react";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import Header from "../components/Header.js";

function HelpIphone() {
  return (
    <Translation>
      {t => (
        <div id="main">
          <Header />
          <div id="wrap">
            <div className="box">
              <h1>{t("iphone.setting_title")}</h1>
              <p>{t("iphone.introduction")}</p>
              <ol>
                <li>{t("iphone.setting_step_1")}</li>
                <li>{t("iphone.setting_step_2")}</li>
                <li>{t("iphone.setting_step_3")}</li>
                <li>{t("iphone.setting_step_4")}</li>
                <li>{t("iphone.setting_step_5")}</li>
              </ol>
              <iframe
                width="315"
                height="560"
                src="https://www.youtube.com/embed/iLACZUNxUBU"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default HelpIphone;
